import styled from 'styled-components';
import { boxFlex } from '../../styled';

export const CloseButtonIconWrapper = styled(boxFlex)`
    height: 24px;
    width: 24px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: ${({ bC }) => bC || 'rgba(0, 0, 0, 0.33)'};
    transition: all 0.4s ease-in-out;
    border-radius: 4px;
    transform: translateY(-50%);
    position: absolute;
    top: ${({ top }) => top || '50%'};
    right: ${({ right }) => right || '24px'};

    &:hover {
        cursor: pointer;
    }
`;
